import { render } from "./FaqView.vue?vue&type=template&id=5a9881a1"
import script from "./FaqView.vue?vue&type=script&lang=js"
export * from "./FaqView.vue?vue&type=script&lang=js"

import "./FaqView.vue?vue&type=style&index=0&id=5a9881a1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__